module.exports = __webpack_public_path__ + "img/contract_b.fe8a692e.svg";